declare const VERSION: string;
declare const BRANCH: string;

console.info(`%c Widget version: ${VERSION}`, "color: green;");
console.info(`%c Widget branch: ${BRANCH}`, "color: green;");
